import { PenIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Pen = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <PenIcon id="pen" size={Sizes[size]} {...rest} color={fill} />;
};

Pen.displayName = 'Pen';
